/** Player colors — HSV spaced like original display.c (hue by slot). */

export interface Rgb {
  r: number;
  g: number;
  b: number;
}

function hsv2rgb(h: number, s: number, v: number): Rgb {
  while (h >= 360) h -= 360;
  while (h < 0) h += 360;
  if (s <= 0) return { r: v, g: v, b: v };
  s = Math.min(1, s);
  h /= 60;
  const i = Math.floor(h);
  const ff = h - i;
  const p = v * (1 - s);
  const q = v * (1 - s * ff);
  const t = v * (1 - s * (1 - ff));
  switch (i) {
    case 0:
      return { r: v, g: t, b: p };
    case 1:
      return { r: q, g: v, b: p };
    case 2:
      return { r: p, g: v, b: t };
    case 3:
      return { r: p, g: q, b: v };
    case 4:
      return { r: t, g: p, b: v };
    default:
      return { r: v, g: p, b: q };
  }
}

export function playerColor(slot: number, maxPlayers = 8): Rgb {
  const groups = Math.min(maxPlayers, 6);
  const h = (360 / groups) * slot + Math.floor(slot / 6) * 30;
  return hsv2rgb(h, 0.85, 1.0);
}

export function rgbCss(c: Rgb, a = 1): string {
  return `rgba(${Math.round(c.r * 255)},${Math.round(c.g * 255)},${Math.round(c.b * 255)},${a})`;
}

export const PLAYER_COLOR_CSS: string[] = Array.from({ length: 8 }, (_, i) => {
  const c = playerColor(i);
  return `rgb(${Math.round(c.r * 255)},${Math.round(c.g * 255)},${Math.round(c.b * 255)})`;
});
